import { useMemo } from "react";
import type { HomesReservation } from "@b2bportal/homes-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";
import { formatDateWithWeekday } from "@/utilities/formatDate";

export const useHomesReservationCard = (reservation: HomesReservation) => {
  const { formatDateTime, t } = useI18nContext();

  const isCancelled = reservation.status.ReservationStatus === "Cancelled";

  const text = useMemo(
    () => ({
      title: reservation.listing.name,
      location: reservation.listing.areaName,
      dates: t("core-hotels.postBooking.summaryCard.dates", {
        fromDate: formatDateWithWeekday(
          dayjs(reservation.stayDates.from).toDate(),
          formatDateTime
        ),
        untilDate: formatDateWithWeekday(
          dayjs(reservation.stayDates.until).toDate(),
          formatDateTime
        ),
      }),
    }),
    [reservation, t, formatDateTime]
  );

  return { text, isCancelled };
};
